import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, Mail, MapPin, ExternalLink } from 'lucide-react';
import { companyInfo } from '../utils/mockData';

const Footer = () => {
  return (
    <footer className="bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900 text-white">
      <div className="container mx-auto px-4 py-12">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8 mb-8">
          {/* Company Info */}
          <div>
            <img 
              src={companyInfo.logo} 
              alt={companyInfo.name}
              className="h-16 w-16 mb-4 bg-white rounded-lg p-2"
            />
            <h3 className="text-xl font-bold mb-3">{companyInfo.name}</h3>
            <p className="text-slate-300 text-sm mb-4">
              {companyInfo.tagline}
            </p>
            <div className="flex flex-col gap-2 text-sm">
              <div className="flex items-start gap-2">
                <MapPin size={16} className="mt-1 flex-shrink-0 text-blue-400" />
                <span className="text-slate-300">{companyInfo.address}</span>
              </div>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-lg font-semibold mb-4">Quick Links</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-slate-300 hover:text-blue-400 transition-colors text-sm">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-slate-300 hover:text-blue-400 transition-colors text-sm">
                  About Us
                </Link>
              </li>
              <li>
                <Link to="/services" className="text-slate-300 hover:text-blue-400 transition-colors text-sm">
                  Our Services
                </Link>
              </li>
              <li>
                <Link to="/projects" className="text-slate-300 hover:text-blue-400 transition-colors text-sm">
                  Projects
                </Link>
              </li>
              <li>
                <Link to="/certifications" className="text-slate-300 hover:text-blue-400 transition-colors text-sm">
                  Certifications
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-slate-300 hover:text-blue-400 transition-colors text-sm">
                  Contact Us
                </Link>
              </li>
            </ul>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-lg font-semibold mb-4">Our Services</h4>
            <ul className="space-y-2 text-sm text-slate-300">
              <li>Control Panel Manufacturing</li>
              <li>PLC Programming & Automation</li>
              <li>VFD & Drive Services</li>
              <li>HMI Solutions</li>
              <li>PLC & VFD Repair</li>
              <li>Electrical AMC Services</li>
            </ul>
          </div>

          {/* Contact & Platforms */}
          <div>
            <h4 className="text-lg font-semibold mb-4">Get In Touch</h4>
            <div className="space-y-3 mb-6">
              <a 
                href={`tel:${companyInfo.phone}`}
                className="flex items-center gap-2 text-slate-300 hover:text-blue-400 transition-colors text-sm"
              >
                <Phone size={16} className="text-blue-400" />
                {companyInfo.phone}
              </a>
              <a 
                href={`mailto:${companyInfo.email}`}
                className="flex items-center gap-2 text-slate-300 hover:text-blue-400 transition-colors text-sm"
              >
                <Mail size={16} className="text-blue-400" />
                {companyInfo.email}
              </a>
            </div>

            <h5 className="font-semibold mb-3 text-sm">Find Us Online</h5>
            <div className="space-y-2">
              <a 
                href={companyInfo.indiamart}
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-2 text-slate-300 hover:text-blue-400 transition-colors text-sm"
              >
                <ExternalLink size={14} />
                IndiaMART
              </a>
              <a 
                href={companyInfo.googleBusiness}
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-2 text-slate-300 hover:text-blue-400 transition-colors text-sm"
              >
                <ExternalLink size={14} />
                Google Business
              </a>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-slate-700 pt-6 mt-6">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4 text-sm text-slate-400">
            <p>
              © {new Date().getFullYear()} {companyInfo.name}. All rights reserved.
            </p>
            <p className="flex items-center gap-2">
              GST: <span className="text-slate-300">{companyInfo.gst}</span>
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
